/* global Sys, Services */
Sys.ns("Services");

/**
 * The Response Service keep and publish the responses received from server.
 *
 * @class Services.Response
 * @extends Services.Base
 */
Services.Response = {

    constructor: function(config) {
        Services.Response.superclass.constructor.apply(this, arguments);
        this._initResponse = config.initResponse;
        this._serverResponse = config.initResponse;
    },

    /**
     * Attach event listener for Services.Response
     *
     * @private
     * @returns {void}
     */
    _setupEvents: function() {
        this.observable.on({
            "notify:responseParser.responseParsed": this._onResponseParsed.bind(this)
        });
    },

    /**
     * Init response received from server.
     *
     * @returns {Object} Init response received from server.
     */
    getInitResponse: function() {
        return this._initResponse;
    },

    /**
     * Recent response received from server.
     *
     * @returns {Object} Recent response received from server.
     */
    getServerResponse: function() {
        return this._serverResponse;
    },

    /**
     * Triggered when server response is parsed and used to save the response.
     *
     * @param {Object} serverResponse – parsed server response.
     * @private
     * @returns {void}
     */
    _onResponseParsed: function(serverResponse) {
        this._serverResponse = serverResponse;
        this.publish("response", serverResponse);

        if (serverResponse.restore === true) {
            this.publish("restored", serverResponse);
        }
    }
};

Services.Response = Sys.extend(Services.Base, Services.Response, "Services.Response");
